(() => {
  const form = document.getElementById("reset-provider-application");
  if (!form || form.dataset.signupReady) return;
  const status = form.querySelector("[data-provider-api-status]");
  const submit = form.querySelector(".reset-provider__submit");
  const password = form.querySelector("#reset-provider-password");
  const confirm = form.querySelector("#reset-provider-password-confirm");
  const say = (text, error = false) => {
    status.hidden = false;
    status.textContent = text;
    status.classList.toggle("reset-provider__form-message--error",error);
    status.classList.toggle("reset-provider__form-message--success",!error);
    status.setAttribute("role",error ? "alert" : "status");
    status.focus();
  };
  if (!window.supabase) { say(form.dataset.signupError,true); return; }
  // No Shopify session, password email, URL payload, or browser business-data cache.
  const sb = window.supabase.createClient("https://akexzbkbcewcmfvtokqo.supabase.co",
    "sb_publishable_IBqWoYVaWYSeP18CRZycUw_6Z9kCCMh",
    { auth: { flowType: "implicit", persistSession: false, autoRefreshToken: false, detectSessionInUrl: false } });
  const allowed = ["First name","Last name","Suffix","email","Phone","Trade name","Practice phone","Practice email","Primary contact title","Company or organization","Business type","Website","NPI number","State license number","Reseller permit number","NPI owner matches contact","Reseller license","Address line 2","Business address","City","State","ZIP code","Credentials","Specialty","License state","License expiration","Professional credential type","Referred by","Verification documents available","Certificate jurisdiction","Certificate expiration","Comments","Research use acknowledgment"];
  const resources = {"AL":"https://www.revenue.alabama.gov/faqs/how-do-i-apply-or-register-for-a-sales-tax-number/","AK":"https://arsstc.org/business-sellers/","AZ":"https://azdor.gov/","AR":"https://www.dfa.arkansas.gov/","CA":"https://cdtfa.ca.gov/formspubs/cdtfa230.pdf","CO":"https://tax.colorado.gov/DR5002","CT":"https://portal.ct.gov/-/media/drs/forms/1995forms/resale-certificate.pdf","DE":"https://revenue.delaware.gov/business-tax-forms/exemption-certificates/","DC":"https://otr.cfo.dc.gov/","FL":"https://www.floridarevenue.com/taxes/eservices/Pages/print_resale.aspx","GA":"https://dor.georgia.gov/","HI":"https://tax.hawaii.gov/","ID":"https://tax.idaho.gov/","IL":"https://tax.illinois.gov/","IN":"https://www.in.gov/dor/","IA":"https://revenue.iowa.gov/","KS":"https://www.ksrevenue.gov/","KY":"https://revenue.ky.gov/","LA":"https://revenue.louisiana.gov/","ME":"https://www.maine.gov/revenue/","MD":"https://www.marylandcomptroller.gov/","MA":"https://www.mass.gov/orgs/massachusetts-department-of-revenue","MI":"https://www.michigan.gov/taxes","MN":"https://www.revenue.state.mn.us/","MS":"https://www.dor.ms.gov/","MO":"https://dor.mo.gov/","MT":"https://revenue.mt.gov/taxes/general-sales-tax","NE":"https://revenue.nebraska.gov/","NV":"https://tax.nv.gov/wp-content/uploads/2024/03/TAX-F005-Resale-Certificate-1.pdf","NH":"https://www.revenue.nh.gov/faq/does-new-hampshire-have-sales-tax","NJ":"https://www.nj.gov/treasury/taxation/","NM":"https://www.tax.newmexico.gov/","NY":"https://www.tax.ny.gov/","NC":"https://www.ncdor.gov/","ND":"https://www.tax.nd.gov/","OH":"https://dam.assets.ohio.gov/image/upload/tax.ohio.gov/forms/fill-in/sales_and_use/exemption_certificates/ST_STEC_B_FI.pdf","OK":"https://oklahoma.gov/tax.html","OR":"https://www.oregon.gov/dor/forms/FormsPubs/or-business-registry-resale-cert_800-002.pdf","PA":"https://www.pa.gov/agencies/revenue","PR":"https://hacienda.pr.gov/ivu/comerciantes-revendedores","RI":"https://tax.ri.gov/","SC":"https://dor.sc.gov/","SD":"https://dor.sd.gov/","TN":"https://www.tn.gov/revenue.html","TX":"https://comptroller.texas.gov/forms/01-339.pdf","UT":"https://tax.utah.gov/","VT":"https://tax.vermont.gov/","VA":"https://www.tax.virginia.gov/","WA":"https://dor.wa.gov/manage-business/my-dor-help/reseller-permit","WV":"https://tax.wv.gov/","WI":"https://www.revenue.wi.gov/","WY":"https://revenue.wyo.gov/"};
  const state = form.querySelector('[name="contact[Certificate jurisdiction]"]');
  const resource = form.querySelector("[data-certificate-resource]");
  state.addEventListener("change", () => {
    resource.hidden = !resources[state.value];
    if (!resource.hidden) resource.href = resources[state.value];
  });
  const certificateFile = form.querySelector("[data-certificate-file]");
  const certificateSave = form.querySelector("[data-certificate-save]");
  const certificateStatus = form.querySelector("[data-certificate-status]");
  let savingCertificate = false;
  let creatingAccount = false;
  let certificateSaved = false;
  const pendingUpload = {};
  const readFields = () => {
    const data = new FormData(form);
    const fields = Object.fromEntries(allowed.map(name => [name,String(data.get("contact[" + name + "]") || "").trim()]));
    fields["Primary contact"] = [fields["First name"],fields["Last name"]].filter(Boolean).join(" ").slice(0,120);
    fields["Practice email"] ||= fields.email;
    return fields;
  };
  if (certificateSave) certificateSave.addEventListener("click", async () => {
    if (savingCertificate || creatingAccount) return;
    savingCertificate = true;
    certificateSave.disabled = true;
    certificateSaved = false;
    certificateStatus.hidden = false;
    certificateStatus.textContent = form.dataset.certificateBusy;
    certificateStatus.setAttribute("role", "status");
    try {
      const { saveWebsiteCertificate } = await import(form.dataset.certificateModule);
      const fields = readFields();
      await saveWebsiteCertificate(sb, {
        email: fields.email, password: password.value,
        file: certificateFile.files[0], fields,
        details: { jurisdiction: state.value, expires_on: fields["Certificate expiration"] || null },
        validatePractice: () => {
          const disabled = [];
          for (const control of [confirm]) { disabled.push([control,control.disabled]); control.disabled = true; }
          try { return form.reportValidity(); } finally { for (const [control,value] of disabled) control.disabled = value; }
        }
      }, pendingUpload);
      certificateSaved = true;
      certificateStatus.textContent = form.dataset.certificateSaved + " " + certificateFile.files[0].name;
      certificateStatus.setAttribute("role", "status");
      certificateSave.disabled = true;
      submit.disabled = true;
      password.value = ""; confirm.value = "";
    } catch (error) {
      certificateStatus.textContent = error instanceof Error ? error.message : form.dataset.signupError;
      certificateStatus.setAttribute("role", "alert");
    } finally {
      savingCertificate = false;
      certificateSave.disabled = certificateSaved;
    }
  });
  if (certificateFile) certificateFile.addEventListener("change", () => {
    certificateSaved = false;
    certificateSave.disabled = savingCertificate;
    certificateStatus.hidden = false;
    certificateStatus.textContent = form.dataset.certificateSelected;
    certificateStatus.setAttribute("role", "status");
  });
  let submitting = false;
  form.dataset.signupReady = "true";
  form.addEventListener("submit",async event => {
    event.preventDefault();
    if (submitting || savingCertificate || !form.reportValidity()) return;
    if (password.value.length < 8 || password.value !== confirm.value) {
      say(form.dataset.passwordError,true); return;
    }
    const data = new FormData(form);
    if (String(data.get("contact[Company fax]") || "").trim()) return;
    const fields = Object.fromEntries(allowed.map(name => [name,String(data.get("contact[" + name + "]") || "").trim()]));
    fields["Primary contact"] = [fields["First name"],fields["Last name"]].filter(Boolean).join(" ").slice(0,120);
    fields["Practice email"] ||= fields.email;
    fields["Submitted at"] = new Date().toISOString();
    submitting = true; creatingAccount = true; submit.disabled = true; submit.textContent = form.dataset.signupBusy;
    try {
      const { error } = await sb.auth.signUp({
        email: fields.email, password: password.value,
        options: { emailRedirectTo: "https://reset-provider-portal.vercel.app/",
          data: { provider_application: { version: 1, fields } } }
      });
      if (error) throw error;
      password.value = ""; confirm.value = "";
      say(form.dataset.signupSuccess);
      submit.disabled = true;
      confirm.required = false;
      if (certificateFile?.files.length) {
        certificateStatus.hidden = false;
        certificateStatus.textContent = form.dataset.certificatePending;
      }
      const link = document.createElement("a");
      link.className = "reset-provider__button reset-provider__button--orange";
      link.href = "https://reset-provider-portal.vercel.app/";
      link.textContent = form.dataset.portalLabel;
      status.append(document.createElement("br"),link);
    } catch (error) {
      say(error instanceof Error ? error.message : form.dataset.signupError,true);
      submitting = false; submit.disabled = false; submit.textContent = form.dataset.signupReadyLabel;
    } finally {
      creatingAccount = false;
    }
  });
  submit.disabled = false;
})();
